export default __webpack_public_path__ + "8e1b2bcf3a45d74d98f0f73f05d58d5b.jpg";